/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { V1ExtendedUserRequestModel } from '../../entities/v1/ExtendedUserRequestModel'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { v1RequestStateStringSchema } from './requestStateStringSchema'
import { z } from 'zod'

export const v1ExtendedUserRequestModelSchema = z.object({
  city_name: z.string(),
  comment: z.string(),
  created_at: z.string(),
  deleted_at: z.string().optional(),
  drivee_city_id: z.number().int(),
  drivee_transport_type_id: z.number().int(),
  drivee_user_id: z.number().int(),
  first_name: z.string(),
  id: z.string(),
  is_active: z.boolean(),
  last_name: z.string(),
  middle_name: z.string(),
  phone: z.string(),
  public_id: z.number().int(),
  reason_summary: z.string(),
  state: z.lazy(() => v1RequestStateStringSchema),
  transport_name: z.string(),
}) as unknown as ToZod<V1ExtendedUserRequestModel>